import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_EXPO } from './ease';

/**
 * 大きな日本語の見出しの後ろに置く、透けた英語（2026-10-17 代表指示: デザインとして）。
 * - 置き場所の親（セクションの中の箱）は relative にする。ここで親いっぱいの枠を作って、はみ出しを切る。
 * - 文字はとても薄くし、読み上げない。押せない（下の文字やボタンの邪魔をしない）。
 * - 位置と大きさは className で渡す（例: "right-[-2%] top-[6%] text-[17vw] 2xl:text-[260px]"）。
 */
export default function GhostWord({ children, className = '', dark = false }) {
  const reduce = useReducedMotion();
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 select-none overflow-hidden">
      <motion.span
        className={`display-type absolute whitespace-nowrap leading-[0.82] ${
          dark ? 'text-paper/[0.04]' : 'text-ink/[0.05]'
        } ${className}`}
        initial={reduce ? false : { opacity: 0, x: 48 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: '-10% 0px' }}
        transition={{ duration: 1.4, ease: EASE_EXPO }}
      >
        {children}
      </motion.span>
    </div>
  );
}
